import { useSession } from "next-auth/react";
import { useQuery } from "react-query";
import { Fragment, type ReactElement } from "react";
import { getSummary } from "../api/tournaments";
import GolfSpinner from "./Icons/GolfSpinner";
import CurrentTournamentHeader from "./CurrentTournamentHeader";
import ScoreSummary from "./ScoreSummary";

const Summary = (): ReactElement => {
  const { data: session }: any = useSession();
  const accessToken: string = session?.accessToken;

  let tournamentOpen = false;
  const { isLoading, error, data } = useQuery<any, Error, any>(
    "homeSummary",
    async () => {
      return getSummary(accessToken);
    },
    {
      enabled: !!accessToken,
    },
  );

  if (data) {
    tournamentOpen = data?.Status !== "CLOSED";
  }

  if (isLoading) {
    return (
      <div className="flex justify-center h-200">
        <GolfSpinner width={50} height={50} />
      </div>
    );
  }

  if (error != null)
    return <div>{"An error has occurred: " + error.message}</div>;
  if (data) {
    if (data.Status != "CLOSED") {
      return (
        <Fragment>
          <div className="col-span-2">
            <CurrentTournamentHeader
              name={data.CurrentTournament.name}
              date={data.CurrentTournament.date}
              lastUpdated={data.CurrentTournament.lastUpdated}
              status={data.Status}
              entry={data.CurrentTournament.entry}
              globalPoolId={data.CurrentTournament.globalPoolId}
              picture={data.CurrentTournament.picture}
            />
          </div>
          {data.Status === "LOCKED" ? (
            <div className="col-span-1">
              <ScoreSummary pools={data.CurrentTournament.myPools} />
            </div>
          ) : null}
        </Fragment>
      );
    } else {
      return (
        <Fragment>
          <div className="col-span-2">
            <CurrentTournamentHeader status={data.Status} />
          </div>
        </Fragment>
      );
    }
  } else return <div>Nothing to see here</div>;
};

export default Summary;
